module.exports = __webpack_public_path__ + "static/media/paso-4.e946336b.png";